import styled from 'styled-components'
import tw from 'twin.macro'

import { Page } from '@/components/page/Page'
import { FeaturedHomeDetails } from '@/components/homes/FeaturedHomeDetails'
// import * as redCurrant10208 from '@/homes/10208-redCurrant/info'
import * as elPaseo14584 from '@/homes/14584-elPaseo/info'
import * as seminole9209 from '@/homes/9209-seminole-156/info'
import * as seminole9209_27 from '@/homes/9209-seminole-27/info'
import * as birchwood7810 from '@/homes/7810-birchwood/info';
import * as tudor9115 from '@/homes/9115-tudor-e106/info';
import * as northside2465 from '@/homes/2465-northside/info'
import { DefaultPageStyles } from '@/styles/page'
import SEO from '@/utils/SEO'

const HomesStyling = styled(DefaultPageStyles)`
  h3 {
    ${tw`text-left`}
  }
  a:hover {
    ${tw`text-primary-500 underline`}
  }
`
export const HomesPage = () => {
  return (
    <Page>
      <SEO
        title="Tampa Bay Featured Homes and Search"
        description="Find your dream home in Tampa Bay. Browse our featured homes selection or search homes via our Tampa Bay map."
        type="website"
      />
      <HomesStyling>
        <h1>Homes in Tampa Bay</h1>
        <h3>Featured</h3>
        <br />
        <FeaturedHomeDetails
          data={tudor9115.data}
          details={tudor9115.details}
        />
        <br />
        <FeaturedHomeDetails
          data={seminole9209.data}
          details={seminole9209.details}
        />
        <br />
        <FeaturedHomeDetails
          data={elPaseo14584.data}
          details={elPaseo14584.details}
        />
        <br />
      </HomesStyling>
    </Page>
  )
}
